var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChartTypesGrouped = function SvgIconsChartTypesGrouped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 9a1 1 0 0 1 .993.883L19 10v10a1 1 0 0 1-1.993.117L17 20V10a1 1 0 0 1 1-1zm-6-6a1 1 0 0 1 .993.883L13 4v16a1 1 0 0 1-1.993.117L11 20V4a1 1 0 0 1 1-1zM6 13a1 1 0 0 1 .993.883L7 14v6a1 1 0 0 1-1.993.117L5 20v-6a1 1 0 0 1 1-1z"
  }))));
};
export default SvgIconsChartTypesGrouped;